<!-- We need this container in order to make the header and content appear one after the other vertically and the footer always at the bottom -->
<!-- That way the modal can be adjusted to be any height and the footer will stick to the bottom and not directly after the content -->
<div class="main-container">
  <!-- Top content - wraps header and scrollable content -->
  <div class="top-section">
    <div class="panel-header">
      <div class="title-section">
        <h2 class="title">{{ dialogTitle }}</h2>
        <h3 class="sub-title">{{ dialogSubTitle }}</h3>
      </div>

      <button class="close-button" matIconButton (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-dialog-content class="panel-content">
      <ng-content></ng-content>
    </mat-dialog-content>
  </div>

  <!-- Bottom content -->
  <mat-dialog-actions class="panel-footer">
    <ng-content select="[panel-footer]"></ng-content>
  </mat-dialog-actions>
</div>
